import { Recipient } from './Recipient';

export class InvalidNumbers {
    public recipients: Recipient[];

    constructor() {
        this.recipients = new Array<Recipient>();
    }
}
